<script>
	let component;

	$: address = component?.innerText;
</script>

<a bind:this={component} class="link" href="mailto:{address}"><slot /></a>
